import arrayBufferViewCore from '../internals/array-buffer-view-core.js';
import functionUncurryThis from '../internals/function-uncurry-this.js';

var ArrayBufferViewCore = arrayBufferViewCore;
var uncurryThis = functionUncurryThis;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $join = uncurryThis([].join); // `%TypedArray%.prototype.join` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.join

exportTypedArrayMethod('join', function join(separator) {
  return $join(aTypedArray(this), separator);
});
